// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 404
import NotFound from '@/views/NotFound';
// 首页
import index from '@/views/index';

// 素材解析
import Scjx from '@/views/scjx/Scjx';

// 用户管理
import WxUser from '@/views/user/WxUser';
// 系统账户管理
import user from '@/views/system/user';
//卡密管理
import Kami from '@/views/kami/Kami';
//日志管理
import Log from '@/views/log/Log';


// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
            path: '/NotFound',
            name: 'NotFound',
            component: NotFound,
            hidden: true
    },
        {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/scjx/Scjx',
            name: '素材解析',
            component: Scjx,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/user/WxUser',
            name: '交易订单',
            component: WxUser,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        },{
            path: '/kami/Kami',
            name: '卡密管理',
            component: Kami,
            meta: {
                requireAuth: true
            }
        },{
            path: '/log/Log',
            name: '卡密管理',
            component: Log,
            meta: {
                requireAuth: true
            }
        },{
            path: '*',
            component: NotFound
        }
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js